export const OPEN_NOTE = 'OPEN_NOTE';
export const RECEIVE_NOTE_ERROR = 'RECEIVE_NOTE_ERROR';
export const RECEIVE_PAGE_ERROR = 'RECEIVE_PAGE_ERROR';
export const SET_NOTE_FIELDS = 'SET_NOTE_FIELDS';
export const CLOSE_NOTE = 'CLOSE_NOTE';

export const openNote = note => ({
    type: OPEN_NOTE,
    payload: note,
});

export const closeNote = () => ({
    type: OPEN_NOTE,
});

export const setNoteFields = fieldsToUpdate => ({
    type: SET_NOTE_FIELDS,
    payload: fieldsToUpdate,
});

export const receiveNoteError = errorText => ({
    type: RECEIVE_NOTE_ERROR,
    payload: errorText,
});

export const receivePageError = errorText => ({
    type: RECEIVE_PAGE_ERROR,
    payload: errorText,
});



// WEBPACK FOOTER //
// ./src/actions/note.js